import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import GolferAuthLayout from './GolferAuthLayout';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Pre-fill username if coming from registration
  useEffect(() => {
    if (location.state?.username) {
      setUsername(location.state.username);
    }
  }, [location.state]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post('/login/', { username, password });

      if (response.data.access && response.data.refresh) {
        localStorage.setItem('access_token', response.data.access);
        localStorage.setItem('refresh_token', response.data.refresh);
        localStorage.setItem('user_profile', JSON.stringify({ is_club: false }));
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        localStorage.setItem('isIOSDevice', isIOS ? 'true' : 'false');
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
        setMessage("Login successful");

        const profileResponse = await axiosInstance.get('/check-profile-complete/');
        if (profileResponse.data.profile_complete) {
          navigate('/courses');
        } else {
          navigate('/profile-setup');
        }
      } else {
        setMessage("Failed - both username and password are case sensitive.");
      }
    } catch (error) {
      console.error("Login failed:", error);
      setMessage("Login failed. Invalid credentials.");
    }
  };

  return (
    <GolferAuthLayout
      seoTitle="Login — PrivateIQ"
      seoDescription="Log in to your PrivateIQ account to access private golf club data, reviews, and community."
      canonicalPath="/login"
    >
      <div className="ga-auth-card">
        <div className="ga-auth-badge">Members</div>
        <h1 className="ga-auth-title">Member Login</h1>
        <form onSubmit={handleLogin} className="ga-auth-form">
          <input
            className="ga-auth-input"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            className="ga-auth-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="ga-auth-btn">Login</button>
          {message && (
            <p className={message.includes("successful") ? "ga-auth-success" : "ga-auth-error"}>
              {message}
            </p>
          )}
        </form>
        <div className="ga-auth-links">
          <p>
            Need an account? <Link to="/register">Register</Link>
          </p>
          <p>
            <Link to="/forgot-password">Forgot Password?</Link>
            {' | '}
            <Link to="/forgot-username">Forgot Username?</Link>
          </p>
        </div>
      </div>
    </GolferAuthLayout>
  );
};

export default Login;
